<template>
<w-sliding-popup class="map-property-popup" ref="slidingPopup" :title="title" width="600px" @close="onPopupClose" :defaultContent="false">
  <div slot="content" style="padding: 25px 40px 25px 25px; width: 100%; height: 100%;">
    <el-form :model="formData" :rules="rules" label-width="120px" ref="mapPropertyForm" label-position="top" v-if="activeIndex === 1">
      <el-row>
        <el-form-item label="이름" prop="mapName">
          <!-- <el-input v-model="formData.mapName" :placeholder="mapNamePlaceholder" style="width: calc(100% - 90px);"></el-input>
          <el-button @click="onMapImportClick">맵 불러오기</el-button> -->
          <el-input v-model="formData.mapName" :placeholder="mapNamePlaceholder" :style="showImportBtn ? 'width: calc(100% - 90px);' : ''"></el-input>
          <el-button @click="onMapImportClick" v-if="showImportBtn">맵 불러오기</el-button>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="배경 타입">
          <el-select v-model="formData.backgroundType" style="width: 100%;">
            <el-option key="C" label="색상" value="C"></el-option>
            <el-option key="I" label="이미지" value="I"></el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-form-item label="배경 색상" v-show="formData.backgroundType === 'C'">
            <w-color-field v-model="formData.backgroundColor" :showAlpha="true"></w-color-field>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="배경 이미지" v-show="formData.backgroundType === 'I'">
            <w-image-select v-model="formData.customimageId"></w-image-select>
          </el-form-item>
        </el-row>
      </el-row>
      <el-row>
        <el-form-item label="격자 표현">
          <el-switch v-model="formData.gridShowFlag" :active-value="true" :inactive-value="false"></el-switch>
        </el-form-item>
        <el-collapse-transition>
          <div v-show="formData.gridShowFlag">
            <el-row>
              <el-form-item label="격자 색상">
                <w-color-field v-model="formData.gridColor" :showAlpha="true"></w-color-field>
              </el-form-item>
            </el-row>
            <el-row :gutter="5">
              <el-form-item label="격자 간격 / 굵기">
                <el-col :span="12">
                  <el-input-number v-model="formData.gridSize" controls-position="right" :min="1" :max="1000" style="width: 100%;"></el-input-number>
                </el-col>
                <el-col :span="12">
                  <el-input-number v-model="formData.gridWeight" controls-position="right" :min="1" :max="10" style="width: 100%;"></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </div>
        </el-collapse-transition>
      </el-row>
      <el-row v-if="(type !== 'EDIT' && isNil(copyMapId))">
        <el-form-item label="연결정보">
          <el-switch v-model="formData.isAutomap" :active-value="true" :inactive-value="false"></el-switch>
        </el-form-item>
        <el-collapse-transition>
          <div v-show="formData.isAutomap">
            <div class="title-bar title-h4 dot-title">주기 설정</div>
            <w-period-setting-component class="mr-b25" ref="periodSettingCmp" />
            <div class="mr-b25">
              <w-autotopology-setting-form :schedule-data="scheduleData" type="no-setting" ref="autotopologySettingCmp"/>
            </div>
          </div>
        </el-collapse-transition>
      </el-row>
    </el-form>
    <div v-if="activeIndex === 2" style="width:100%; height:100%">
      <div class="back-title title-bar">
        <i class="el-icon-back c-pointer mr-r4"  @click="onBackClick"></i> 맵 불러오기
      </div>
      <w-map-element-tree style="height: calc(100% - 40px);" ref="mapTree" :elementType="MapConst.ELEMENT_TYPE.SUBMAP" :highlightCurrent="true"></w-map-element-tree>
    </div>
  </div>
  <div slot="footer">
    <div v-if="activeIndex === 1">
      <el-button size="large" type="solid" @click="onSaveClick">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
    <div v-if="activeIndex === 2">
      <el-button size="large" type="solid" @click="onMapImportSelectClick">확인</el-button>
      <el-button size="large" @click="onMapImportCancelClick">취소</el-button>
    </div>
  </div>
</w-sliding-popup>
</template>

<script>
import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';

import WColorField from '@/components/form/ColorField';
import WTextForm from '@/components/formeditor/TextFormEditor';

import Base from '@/mixins/topologymap/base';

import { isEmpty } from '@/utils/basic';
import msgUtil from '@/utils/message';
import { isNil } from 'lodash';

import WMapElementTree from '@/views/topologymap/components/MapElementTree';
import WPeriodSettingComponent from '@/views/settings/components/PeriodSettingComponent';
import WImageSelect from '@/views/topologymap/components/property/ImageSelect';
import WAutotopologySettingForm from '@/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/components/form/AutotopologySettingForm';
import { Q, MapUtil, MapInfo } from '@/views/topologymap/js/maps';
import ScheduleAPI from '@/api/settings/netdevice/schedule';

export default {
  name: 'WMapPropertyPopup',
  components: {
    WColorField,
    WTextForm,
    WMapElementTree,
    WImageSelect,
    WPeriodSettingComponent,
    WAutotopologySettingForm,
  },
  mixins: [Base],
  data() {
    return {
      MapConst,
      activeIndex: 1,
      type: 'ADD', // ADD, ADD_SUB, EDIT
      data: {},
      mapNamePlaceholder: '',
      copyMapId: null,
      formData: {},
      formDataDefault: {
        mapName: '',
        gridShowFlag: false,
        gridColor: 'rgba(255, 255, 255, 1)',
        gridSize: 50,
        gridWeight: 1,
        backgroundType: 'C',
        backgroundColor: 'rgba(255, 255, 255, 1)',
        customimageName: '',
        customimageId: '',
        isAutomap: false,
      },
      scheduleData: {
        scheduleId: null,
        scheduleName: '',
        scheduleTypeId: 'AUTO_TOPOLOGY',
        scheduleContent: null,
      },
      rules: {
        mapName: [
          {
            required: true,
            message: '맵 이름을 입력해주십시오.',
            trigger: 'blur',
          },
        ],
      },
      isNil,
    };
  },
  computed: {
    /**
     * 타이틀 반환
     * @author KangBonghun(toto1323)
     * @return {String} 타이틀
     */
    title() {
      if (this.type === 'ADD') {
        return '맵 추가';
      } else if (this.type === 'ADD_SUB') {
        return `[${this.data.label}] 하위맵 추가`;
      }
      return '맵 속성';
    },
    showImportBtn() {
      if (this.type === 'EDIT' && this.isAutomap) {
        return false;
      }
      return true;
    },
  },
  methods: {
    /**
     * 팝업 오픈 요청
     * @author KangBonghun(toto1323)
     * @param  {[type]} params [description]
     */
    open(params) {
      this.resetForm();
      this.type = params.type;
      this.data = params.data;
      if (this.formData.isAutomap) {
        this.scheduleData = {
          scheduleId: null,
          scheduleName: this.submitModel.label,
          scheduleTypeId: 'AUTO_TOPOLOGY',
          scheduleContent: null,
        };
      }
      this.initFormData(params.model);
      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업 닫기 요청
     * @author KangBonghun(toto1323)
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 팝업 close 콜백 함수
     * @author KangBonghun(toto1323)
     */
    onPopupClose() {
      this.reset();
    },
    /**
     * 맵 불러오기 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onMapImportClick() {
      this.activeIndex = 2;
    },
    /**
     * 맵 불러오기 > 확인 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onMapImportSelectClick() {
      const node = this.$refs.mapTree.getCurrentNode();

      if (isEmpty(node)) {
        this.$message(msgUtil.getCustomMsgData('맵을 선택해주십시오.'));
      } else {
        MapAPI.getTopologymapModel(node.mapId).then((response) => {
          const result = response.data;

          if (result.success) {
            const model = result.data;

            this.copyMapId = model.mapId;

            // 맵 이름이 비어있으면 Placeholder를 불러온 맵의 이름으로 설정해준다.
            if (isEmpty(this.formData.mapName)) {
              this.mapNamePlaceholder = `${model.label} (1)`;
              model.label = '';
            } else {
              model.label = this.formData.mapName;
            }

            // 맵 불러오기하면 무조건 자동맵이 아니다!
            model.isAutomap = false;

            this.restoreFormData(model);
          }
          this.onBackClick();
        });
      }
    },
    /**
     * 맵 불러오기 > 취소 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onMapImportCancelClick() {
      this.onBackClick();
    },
    /**
     * 맵 불러오기 > 뒤로가기 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onBackClick() {
      this.activeIndex = 1;
    },
    /**
     * 저장 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onSaveClick() {
      this.validateForm(); // 유효성 체크
    },
    /**
     * 유효성 체크
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    validateForm() {
      if (this.$refs.mapPropertyForm) {
        this.$refs.mapPropertyForm.validate((valid) => {
          if (valid) {
            // 유효성 체크를 통과하면 저장
            this.save();
          } else if (!isEmpty(this.copyMapId)) {
            this.formData.mapName = this.mapNamePlaceholder;
            this.validateForm();
          }
        });
      }
    },
    /**
     * 입력 폼 리셋
     * @author KangBonghun(toto1323)
     */
    resetForm() {
      this.activeIndex = 1;
      this.type = 'ADD';
      this.mapNamePlaceholder = '';
      this.copyMapId = null;
      this.formData = {};

      if (this.formData.isAutomap) {
        if (!isEmpty(this.$refs.periodSettingCmp)) {
          this.$refs.periodSettingCmp.init();
        }
        if (!isEmpty(this.$refs.autotopologySettingCmp)) {
          this.$refs.autotopologySettingCmp.init();
        }
      }

      if (this.$refs.mapPropertyForm) {
        this.$refs.mapPropertyForm.resetFields();
      }
    },
    /**
     * 추가/수정에 따라 폼 데이터를 초기화한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} model [description]
     * @return {[type]}       [description]
     */
    initFormData(model) {
      if (this.type === 'EDIT') {
        // 수정일 경우 넘겨 받은 데이터를 폼 데이터에 설정한다.
        this.restoreFormData(model);
      } else {
        // 추가일 경우 기본 값으로 설정한다.
        this.formData = Object.assign({}, this.formDataDefault);
      }
    },
    /**
     * 폼 데이터를 복원한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} model [description]
     * @return {[type]}       [description]
     */
    restoreFormData(model) {
      this.formData = {
        mapName: model.label,
        gridShowFlag: model.gridShowFlag === '1',
        gridColor: MapUtil.hexToRgbA(model.strokeOptions.color, model.strokeOptions.alpha),
        gridSize: model.gridSize || 50,
        gridWeight: model.strokeOptions.weight || 1,
        backgroundType: model.fillType === 'Solid Fill' ? 'C' : 'I',
        backgroundColor: MapUtil.hexToRgbA(model.fillOptions.color, model.fillOptions.alpha),
        customimageName: (this.$store.getters.getCustomimage[model.customimageId] && this.$store.getters.getCustomimage[model.customimageId].customimageName) || '',
        customimageId: model.customimageId,
        schedulId: model.schedulId,
        isAutomap: model.isAutomap,
      };
    },
    /**
     * 폼 데이터를 모델로 생성한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} formData [description]
     * @return {[type]}          [description]
     */
    makeSubmitModel(formData) {
      const submitModel = {};
      const fillOptions = {};
      const strokeOptions = {};

      // 부모 맵 아이디 (하위 맵일경우)
      if (this.type === 'ADD_SUB') {
        submitModel.parentMapId = this.data.mapId;
        // submitModel.parentMapId = MapInfo.getInstance(this).getGraph().topologymapModel.mapId;
      }

      // 맵 이름
      submitModel.label = formData.mapName;

      // 배경
      if (formData.backgroundType === 'C') {
        // 색상
        submitModel.fillType = 'Solid Fill';
        fillOptions.color = MapUtil.hex8ToHex6(MapUtil.rgbaToHex(formData.backgroundColor));
        fillOptions.alpha = MapUtil.hex8ToAlpha(MapUtil.rgbaToHex(formData.backgroundColor));

        submitModel.customimageId = null;
      } else {
        // 이미지
        submitModel.fillType = 'Image Fill';
        submitModel.customimageId = formData.customimageId;
      }

      // 격자
      if (formData.gridShowFlag === true) {
        submitModel.gridShowFlag = '1';
        submitModel.gridSize = formData.gridSize;

        strokeOptions.color = MapUtil.hex8ToHex6(MapUtil.rgbaToHex(formData.gridColor));
        strokeOptions.alpha = MapUtil.hex8ToAlpha(MapUtil.rgbaToHex(formData.gridColor));
        strokeOptions.weight = formData.gridWeight;
      } else {
        submitModel.gridShowFlag = '0';

        submitModel.gridSize = null;
      }

      submitModel.fillOptions = fillOptions;
      submitModel.strokeOptions = strokeOptions;

      submitModel.copyMapId = this.copyMapId;

      // 연결정보
      if (formData.isAutomap) {
        submitModel.isAutomap = formData.isAutomap;
      }

      return submitModel;
    },
    /**
     * 저장
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    save() {
      if (this.type === 'EDIT') {
        // 맵 수정
        const canvas = MapInfo.getInstance(this).getCanvas();
        const graph = MapInfo.getInstance(this).getGraph();
        const model = graph.topologymapModel;
        const submitModel = this.makeSubmitModel(this.formData);

        if (!isEmpty(this.copyMapId)) {
          // 맵 불러오기를 했다면
          MapInfo.getInstance(this).mask('불러오는중...');
          MapAPI.getTopologymap(this.copyMapId).then((response) => {
            const result = response.data;

            if (result.success) {
              try {
                const topologymap = result.data.topologymap;

                // 토폴로지맵 세팅
                if (topologymap) {
                  topologymap.mapId = model.mapId;
                  topologymap.label = submitModel.label;

                  graph.topologymapModel = topologymap;
                  graph.background.image = this.$store.getters.getImageUrlById(topologymap.customimageId);

                  const modelData = {
                    imageModels: topologymap.imageModels || [],
                    labelModels: topologymap.labelModels || [],
                    lanModels: topologymap.lanModels || [],
                    managedObjectModels: topologymap.managedObjectModels || [],
                    shapeModels: topologymap.shapeModels || [],
                    subTopologymapModels: topologymap.subTopologymapModels || [],
                    virtualLanModels: topologymap.virtualLanModels || [],
                    virtualObjectModels: topologymap.virtualObjectModels || [],
                    custom1Models: topologymap.custom1Models || [],
                  };

                  canvas.refreshGraphModel(modelData);
                } else {
                  graph.topologymapModel = null;
                  canvas.refreshGraphModel({});
                }
              } catch (e) {
                Q.log(e);
              }
            }
            MapInfo.getInstance(this).unmask();
          });
        } else {
          Object.assign(model, submitModel);
          graph.background.changeModel();
        }

        this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.CHANGE_MAP_NAME, this.formData.mapName);
        this.close();
      } else {
        // 맵 추가
        const submitModel = this.makeSubmitModel(this.formData);

        if (submitModel.isAutomap) {
          this.scheduleData.scheduleName = submitModel.label;

          const data = this.$refs.periodSettingCmp.getPeriodSettingData();
          this.scheduleData.scheduleContent = this.$refs.autotopologySettingCmp.createScheduleContent(data);
          const params = Object.assign(data, this.scheduleData);
          const autotopologySettingData = this.$refs.autotopologySettingCmp.getAutotopologySettingData('add');
          Object.assign(params, autotopologySettingData);

          Object.assign(params.topologymap, submitModel);
          this.$confirm(...msgUtil.getBasicConfirmData('맵을 추가'))
            .then(() => {
              MapInfo.getInstance(this).mask('추가중...');
              this.close();
              ScheduleAPI.addNedeviceSchedule(params)
                .then((response) => {
                  MapInfo.getInstance(this).unmask();
                  if (response.data.success) {
                    this.$emit('loadData');
                    this.$message.success('맵을 추가하였습니다.');
                    this.treeLoad();
                  } else {
                    this.$message.error('맵을 추가하지 못하였습니다.');
                  }
                })
                .catch(() => {
                })
                .finally(() => {
                  this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.TREE_LOAD);
                });
            })
            .catch(() => {});
        } else {
          this.$confirm(...msgUtil.getBasicConfirmData('맵을 추가'))
            .then(() => {
              MapInfo.getInstance(this).mask('추가중...');
              this.close();

              MapAPI.addTopologymap(submitModel).then((response) => {
                MapInfo.getInstance(this).unmask();

                const result = response.data;
                if (result.success) {
                  // const mapId = result.data;
                  this.$message.success('맵을 추가하였습니다.');

                  // this.routeMap(mapId, {
                  //   redirect: false,
                  // });
                  this.treeLoad();
                } else {
                  this.$message.error('맵을 추가하지 못하였습니다.');
                }
                // this.$store.commit('setTopologymapViewMode', MapConst.VIEW_MODE.MONITORING);
              });
            })
            .catch(() => {});
        }
      }
    },
    reset() {
      if (!isEmpty(this.$refs.periodSettingCmp)) {
        this.$refs.periodSettingCmp.init();
      }
      if (!isEmpty(this.$refs.autotopologySettingCmp)) {
        this.$refs.autotopologySettingCmp.init();
      }
    },
  },
};
</script>

<style lang="scss">
.map-property-popup {
  .el-tabs__content {
    padding-top: 10px !important;
    height: calc(100% - 40px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/MapPropertyPopup.vue